import WarningIcon from "@mui/icons-material/Warning";
import { ListItem, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import React from "react";
import { classNames, If } from "react-extras";
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { setNavMenuOpen } from "~/redux/reducers/generalReducer";
import { useAppDispatch } from "~/redux/store/store";
import { NavigationIdType } from "~/store/stores/AlarmIndicatorSlice";
import { useAlarmIndicatorStore } from "~/store/useAlarmIndicatorStore";
import {
  MainMenuButton,
  MainMenuItem,
  MainMenuLink,
  useSharedStyles,
} from "./Navigator";

function IsButton(item: MainMenuItem): item is MainMenuButton {
  return "onClick" in item;
}

export function IsLink(item: MainMenuItem): item is MainMenuLink {
  return "to" in item;
}

interface Props {
  item: MainMenuItem;
  nestLevel: number;
  minified: boolean;
}

const NavigatorButton = ({ item, nestLevel, minified }: Props): JSX.Element => {
  const classes = useSharedStyles();

  const location = useLocation();
  const dispatch = useAppDispatch();
  const { t } = useTranslation("navigation");
  const { hasAlarm, getAlarmIndicator } = useAlarmIndicatorStore();

  // console.log(activeAlarmIndicators);
  const isActive =
    (IsLink(item) && location.pathname === item.to) || item.isActive?.();

  const itemHasAlarm = hasAlarm(item.id as NavigationIdType);

  const alarmIndicator = getAlarmIndicator(item.id as NavigationIdType);

  return (
    <>
      <ListItem
        key={item.id}
        button
        className={classNames(
          classes.item,
          isActive ? classes.itemActiveItem : "",
        )}
        style={{
          paddingLeft: `${isActive ? 16 * nestLevel - 2 : 16 * nestLevel}px`,
        }}
        component={IsLink(item) ? RouterLink : "li"}
        to={IsLink(item) ? item.to : undefined}
        onClick={() => {
          if (IsButton(item)) item.onClick();
          dispatch(setNavMenuOpen(false));
        }}
      >
        <Tooltip title={t(item.translation).toString()}>
          <ListItemIcon className={classes.itemIcon}>{item.icon}</ListItemIcon>
        </Tooltip>
        <If condition={!minified}>
          <ListItemText
            className={classes.itemText}
            classes={{
              primary: classes.itemPrimary,
            }}
          >
            {t(item.translation)}
          </ListItemText>
          {itemHasAlarm && (
            <Tooltip title={alarmIndicator?.message ?? ""}>
              <WarningIcon color="warning" />
            </Tooltip>
          )}
        </If>
      </ListItem>
      {/* <Button
        onClick={() => {
          console.log("CLICKCLIC");
          updateAlarm(item.id, hasAlarm(item.id));
        }}
      >
        Te
      </Button> */}
      {/* <Button
        onClick={() => {
          updateAlarm(item.id, true);
        }}
      >
        remove
      </Button>
      <Button
        onClick={() => {
          updateAlarm(item.id, false);
        }}
      >
        add
      </Button> */}
    </>
  );
};

export default NavigatorButton;
